// Import and register all your controllers from the importmap under controllers/*
import { application } from "./application";

import BulkApprovalTransactionController from "./bulk_approval_transaction_controller";
application.register(
  "bulk-approval-transaction",
  BulkApprovalTransactionController,
);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import CampaignOnboardingController from "./campaign_onboarding_controller";
application.register("campaign-onboarding", CampaignOnboardingController);

import OrganizationSetupController from "./organization_setup_controller";
application.register("organization-setup", OrganizationSetupController);

import StripeCardVerificationController from "./stripe_card_verification_controller";
application.register(
  "stripe-card-verification",
  StripeCardVerificationController,
);
